import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Markdown from 'markdown-to-jsx';
import {
    Box, useMediaQuery, useTheme,
    IconButton, Modal, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { injectIntl, intlShape } from 'react-intl';
import { getPromoBanners, getPromoTerms } from './promoSelectors';
import CartPageMessages from '../cart/messages/cartPageMessages';
import FormButton from '../primitive/buttons/FormButton';
import SkeletonLoader from '../loader/SkeletonLoader';
import { getLoaderStatus } from '../loader/loaderSelector';
import { trackHeaderFooterClick } from '../segment/segmentModule';

const TermsAndConditions = ({
    intl, open, handleClose, content
}) => (
    <Modal open={open} onClose={handleClose}>
        <Box className='terms-condition-modal pop-up-modal-container'>
            <Box className='terms-condition-modal-header modal-header'>
                <Typography className='terms-condition-title'>
                    {intl.formatMessage(CartPageMessages.termsAndConditionsText)}
                </Typography>
                <IconButton aria-label="Close" className='terms-condition-icon' onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box className='terms-condition-modal-body'>
                <Typography className='terms-condition-content'>
                    <Markdown>{content}</Markdown>
                </Typography>
            </Box>
            <FormButton
                className='terms-condition-got-it-btn'
                variant='secondary'
                handleClick={handleClose}
                title={intl.formatMessage(CartPageMessages.gotItButtonText)}
            />
        </Box>
    </Modal>

);

TermsAndConditions.defaultProps = {
    content: ''
};

TermsAndConditions.propTypes = {
    intl: intlShape.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    content: PropTypes.string
};

const PromoBanner = ({
    intl, banners, promoTerms, isLoading, trackExternalLinkClickAction, renderMobileBanner
}) => {
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => {
        trackExternalLinkClickAction(
            'Link Click',
            {
                title: intl.formatMessage(CartPageMessages.termsAndConditionsText),
                destinationUrl: 'POP-UP'
            }
        );
        setOpen(true);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    if (!banners) {
        return null;
    }

    const banner = (renderMobileBanner || isMobile) ? banners.small : banners.large;
    return (
        <Box className='promo-banner'>
            {}
            <SkeletonLoader
                isLoading={isLoading}
                skeletonProps={{
                    animation: 'wave',
                    variant: 'rectangular',
                    className: 'skeletonclass',
                    height: 80
                }}
            >
                {banner && (
                    <Markdown className={renderMobileBanner ? 'promo-mobile-banner-image' : 'promo-banner-image'}>
                        {banner}
                    </Markdown>
                )}
            </SkeletonLoader>

            {}
            {promoTerms && (
                <Box className='promo-terms'>
                    <FormButton
                        className='promo-terms-link'
                        handleClick={handleOpen}
                        title={intl.formatMessage(CartPageMessages.termsAndConditionsText)}
                    />
                    <TermsAndConditions
                        intl={intl}
                        content={promoTerms}
                        open={open}
                        handleClose={handleClose}
                    />
                </Box>
            )}
        </Box>

    );
};

PromoBanner.defaultProps = {
    banners: null,
    promoTerms: '',
    isPlasticBanner: false,
    renderMobileBanner: false
};

PromoBanner.propTypes = {
    intl: intlShape.isRequired,
    banners: PropTypes.object,
    promoTerms: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    
    isPlasticBanner: PropTypes.bool,
    renderMobileBanner: PropTypes.bool,
    trackExternalLinkClickAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
    banners: getPromoBanners(state, ownProps.isPlasticBanner),
    promoTerms: getPromoTerms(state),
    isLoading: getLoaderStatus(state)
});

const mapDispatchToProps = {
    trackExternalLinkClickAction: trackHeaderFooterClick
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PromoBanner));
